import Image from 'next/image';
import { map } from 'lodash-es';
import { SALES_AND_MARKETING_HEADER_CONTENT } from '@/shared/constants/platform-pages-constants';
import './index.less';
import cN from 'classnames';
import { useCreateAccountProvider } from '@/lib/context';

interface IProps {
  title?: string;
  description?: string;
  className?: string;
}

const PlatformSalesAndMarketing = ({ title, description, className }: IProps) => {
  const { showSignupDialog } = useCreateAccountProvider();

  return (
    <div className={cN('platform-sales-and-marketing', className)}>
      {title && <div className="title">{title}</div>}
      {description && <div className="description">{description}</div>}
      <div className="list">
        {map(SALES_AND_MARKETING_HEADER_CONTENT.heroBanner, ({ title, description, remark, imageUrl }) => (
          <div className="item" key={title} onClick={showSignupDialog}>
            <div className="item-icon">
              <Image unoptimized src={imageUrl} width={40} height={40} alt={title} />
            </div>
            <div className="title">{title}</div>
            <div className="description">{description}</div>
            <div className="remark">{remark}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlatformSalesAndMarketing;
